<template>
  <div>
    <cx-check-box :value.sync="showTooltip">显示提示框</cx-check-box>
    <div v-if="showTooltip">
      <div class="data-item mt16">
        <double-input
          title="尺寸"
          placeHolderText="必填"
          :value1.sync="tooltipWidth"
          :value2.sync="tooltipHeight"
          :inputSuffixs="['宽', '高']"
        />
      </div>
      <div class="data-item mt16">
        <span class="font14 mr8">触发方式</span>
        <el-radio-group v-model="tooltipTriggerOn">
          <el-radio label="mousemove">悬浮</el-radio>
          <el-radio label="click">点击</el-radio>
        </el-radio-group>
      </div>
      <div class="data-item mt16 verticallyCenter">
        <span class="font14 mr8">显示位置</span>
        <el-radio-group v-model="tooltipPosition">
          <el-radio class="mr20" label="auto">自适应</el-radio>
          <el-radio label="fixed">固定位置</el-radio>
        </el-radio-group>
      </div>
      <div class="mt12" v-show="tooltipPosition == 'fixed'">
        <slider-and-input :value.sync="tooltipPositionX" title="横轴" titlePosition="allInOneLine" suffix="%" />
        <slider-and-input
          class="mt12"
          :value.sync="tooltipPositionY"
          title="纵轴"
          titlePosition="allInOneLine"
          suffix="%"
        />
      </div>
      <div class="data-item mt16">
        <label class="font14 inlineMiddle"> 文字样式 </label>
        <text-setting-update
          class="mt8"
          :fontColor.sync="tooltipFontColor"
          :fontFamily.sync="tooltipFontFamily"
          :fontSize.sync="tooltipFontSize"
          :fontWeight.sync="tooltipFontWeight"
        />
      </div>
      <div class="data-item mt16">
        <cx-padding
          :paddingTypeFlag.sync="tooltipPaddingTypeFlag"
          :padding.sync="tooltipPadding"
          :paddingTop.sync="tooltipPaddingTop"
          :paddingRight.sync="tooltipPaddingRight"
          :paddingBottom.sync="tooltipPaddingBottom"
          :paddingLeft.sync="tooltipPaddingLeft"
        />
      </div>
      <div class="mt16">
        <div class="mb16">边框</div>
        <cx-border
          :borderWidth.sync="tooltipBorderWidth"
          :borderStyle.sync="tooltipBorderStyle"
          :borderColor.sync="tooltipBorderColor"
          :borderIsThemeColor.sync="tooltipBorderIsThemeColor"
        />
      </div>
      <div class="mt16">
        <!--提示框背景颜色-->
        <cx-background :background.sync="tooltipBackgroundColor" imgType="10" class="mt16" />
      </div>
      <div class="mt16" v-if="showAutoPlaySetting">
        <cx-check-box :value.sync="isAutoPlayToolTip">自动轮播</cx-check-box>
        <slider-and-input
          class="mt16"
          v-if="isAutoPlayToolTip"
          :value.sync="autoPlayToolTipIntervalTime"
          title="停留时间"
          :sliderMax="600"
          :sliderMin="1"
          suffix="s"
          inputWidth="small"
          inputHeight="small"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { options: Object, showAutoPlaySetting: {
    type: Boolean,
    default: true
  } },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },

    chartOption() {
      return this.options.chartOption
    },
    showTooltip: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.show", "tooltip.show", false)
      },
      set(val) {
        if (!this.chartOption.tooltip) {
          this.$changeOptionsEV({}, "chartOption.tooltip", false)
        } else {
          this.$changeOptionsEV({ show: val }, "chartOption.tooltip", false)
        }
      }
    },
    tooltipWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipWidth", "tooltip.tooltipWidth", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.tooltip.tooltipWidth", false)
      }
    },
    tooltipHeight: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipHeight", "tooltip.tooltipHeight", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.tooltip.tooltipHeight", false)
      }
    },
    tooltipFontColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipFontColor",
          "tooltip.tooltipFontColor",
          "#000"
        )
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipFontColor", false)
      }
    },
    tooltipFontFamily: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipFontFamily",
          "tooltip.tooltipFontFamily",
          "sans-serif"
        )
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipFontFamily", false)
      }
    },
    tooltipFontSize: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipFontSize", "tooltip.tooltipFontSize", 12)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipFontSize", false)
      }
    },
    tooltipFontWeight: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipFontWeight",
          "tooltip.tooltipFontWeight",
          400
        )
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipFontWeight", false)
      }
    },
    tooltipTriggerOn: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipTriggerOn",
          "tooltip.tooltipTriggerOn",
          "mousemove"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipTriggerOn", false)
      }
    },
    tooltipPosition: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipPosition",
          "tooltip.tooltipPosition",
          "auto"
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPosition", false)
      }
    },
    tooltipPositionX: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPositionX", "tooltip.tooltipPositionX", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.tooltip.tooltipPositionX", false)
      }
    },
    tooltipPositionY: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPositionY", "tooltip.tooltipPositionY", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "chartOption.tooltip.tooltipPositionY", false)
      }
    },
    // 边距
    tooltipPaddingTypeFlag: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipPaddingTypeFlag",
          "tooltipPaddingTypeFlag",
          1
        )
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPaddingTypeFlag", false)
      }
    },
    tooltipPadding: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPadding", "tooltipPadding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPadding", false)
      }
    },
    tooltipPaddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPaddingTop", "tooltipPaddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPaddingTop", false)
      }
    },
    tooltipPaddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPaddingRight", "tooltipPaddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPaddingRight", false)
      }
    },
    tooltipPaddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPaddingLeft", "tooltipPaddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPaddingLeft", false)
      }
    },
    tooltipPaddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipPaddingBottom", "tooltipPaddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "chartOption.tooltip.tooltipPaddingBottom", false)
      }
    },
    // 描边
    tooltipBorderWidth: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "tooltip.tooltipBorderWidth", "tooltipBorderWidth", 0)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipBorderWidth", false)
      }
    },
    tooltipBorderColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipBorderColor",
          "tooltip.tooltipBorderColor",
          "transparent"
        )
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipBorderColor", false)
      }
    },
    tooltipBorderStyle: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipBorderStyle",
          "tooltip.tooltipBorderStyle",
          "solid"
        )
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipBorderStyle", false)
      }
    },
    tooltipBorderIsThemeColor: {
      get() {
        return this.checkAndSetPrimaryVal(
          this.chartOption,
          "tooltip.tooltipBorderIsThemeColor",
          "tooltip.tooltipBorderIsThemeColor",
          false
        )
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltip.tooltipBorderIsThemeColor", false)
      }
    },
    tooltipBackgroundColor: {
      get() {
        let background = this.chartOption.tooltipBackgroundColor
        let backgroundOld = this.chartOption.tooltip.tooltipBackgroundColor
        if (background && Array.isArray(background) && background.length > 0) {
          return this.chartOption.tooltipBackgroundColor
        }else if(backgroundOld && Array.isArray(backgroundOld) && backgroundOld.length > 0){
          return this.chartOption.tooltip.tooltipBackgroundColor
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: "rgba(255, 255, 255, 1)"
          }
        ]
        this.$changeOptionsEV(newBackground, "chartOption.tooltipBackgroundColor", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.tooltipBackgroundColor", false)
      }
    },
    isAutoPlayToolTip: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOption, "isAutoPlayToolTip", "isAutoPlayToolTip", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.isAutoPlayToolTip", false)
      }
    },
    autoPlayToolTipIntervalTime: {
      get() {
        let time1 = this.checkAndSetPrimaryVal(
          this.chartOption,
          "autoPlayToolTipIntervalTime",
          "autoPlayToolTipIntervalTime",
          1000
        )
        return time1/1000
      },
      set(newVal) {
        this.$changeOptionsEV(newVal * 1000, "chartOption.autoPlayToolTipIntervalTime", false)
      }
    }
  },

  methods: {}
}
</script>

<style>
.el-radio.mr20 {
  margin-right: 20px;
}
</style>
